import { EMAIL } from "../config";
const Contact = () => {
  return (
    <div className="contact">
      <div className="contact__title">
        <h2>Have questions? Let’s chat!</h2>
        <p>
          Got a question? We’re here to help! Feel free to ask—we’d love to hear
          from you.
        </p>
      </div>
      <div className="contact__button">
        <a href={EMAIL} aria-label="Email us at contact@hiko.com">
          contact us
        </a>
      </div>
    </div>
  );
};

export default Contact;
